// testimonials reveal
jQuery( document ).ready(function() {
  jQuery('.testimonials .load_more, .subscribe_careers button').click( function(e) {
    jQuery(this).closest('section').toggleClass('open');

    if( jQuery('#mc_embed_signup') ) {
      jQuery('#mc_embed_signup :input:enabled:visible:first').focus();
      jQuery('html, body').animate({ 
        scrollTop: '+=200px'
      }, 300);
    }

    return false;
  });
});
